export enum childNames {
  BLUE = 'blue',
  ORANGE = 'orange',
  PURPLE = 'purple',
  PINK = 'pink',
  GREY = 'grey',
  YELLOW = 'yellow',
}
export type propsChild = {
  name: childNames;
  start: boolean;
  stop: boolean;
  fall: boolean;
  reachedTargets: boolean;
  isDied: boolean;
  img: string;
  anchorImg: string;
  anim: {
    up: string;
    down: string;
  };
};

export interface typeState {
  children: propsChild[];
}
